import { render, staticRenderFns } from "./purchaseRequisition-add-or-update.vue?vue&type=template&id=6ab0ed29&scoped=true"
import script from "./purchaseRequisition-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseRequisition-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseRequisition-add-or-update.vue?vue&type=style&index=0&id=6ab0ed29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab0ed29",
  null
  
)

export default component.exports